export default function CircularMenuButton(props) {
  const { handleClick, iconClass } = props;

  return <a onClick={handleClick} className={`menu-item fas ${iconClass}`}></a>;
}
